import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function HeroSection() {
  const [ref, isVisible] = useScrollAnimation(0.1);

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section data-testid="hero-section" className="relative pt-28 pb-20 md:pt-40 md:pb-32 px-4 md:px-8 overflow-hidden">
      {/* Mesh gradient background */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-vf-mint/[0.08] rounded-full blur-[120px] -translate-y-1/3 translate-x-1/4" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-vf-mint/[0.06] rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" />
        <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-vf-sage/[0.1] rounded-full blur-[80px] -translate-x-1/2 -translate-y-1/2" />
      </div>
      <div ref={ref} className={`relative max-w-4xl mx-auto text-center scroll-fade-up ${isVisible ? 'visible' : ''}`}>
        {/* Overline */}
        <p className="uppercase text-xs tracking-[0.25em] text-vf-forest font-body font-bold mb-6">
          AI-Powered Clinical Documentation
        </p>

        {/* Headline */}
        <h1
          data-testid="hero-h1"
          className="font-heading font-bold text-4xl sm:text-5xl lg:text-6xl text-vf-forest tracking-[-0.01em] leading-[1.08] mb-6"
        >
          Rural America's clinics are dying from paperwork.
        </h1>

        {/* Subheadline */}
        <p className="font-body text-base md:text-lg font-semibold text-vf-charcoal max-w-2xl mx-auto mb-10 leading-relaxed">
          VitalsFlow AI automates documentation and billing for the 60 million Americans
          left behind by Silicon Valley. We don't just cut paperwork — we recover lost revenue.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button
            data-testid="hero-cta-primary"
            onClick={() => scrollTo('#demo-form')}
            className="font-body text-sm font-bold uppercase tracking-[0.18em] bg-vf-mint text-vf-charcoal px-10 py-5 shadow-lg hover:shadow-xl hover:bg-vf-mint/85 transition-all duration-300 w-full sm:w-auto"
          >
            Request Pilot Access
          </button>
          <button
            data-testid="hero-cta-secondary"
            onClick={() => scrollTo('#how-it-works')}
            className="font-body text-sm font-medium text-vf-forest border-b-2 border-vf-forest/30 hover:border-vf-forest pb-1 transition-all duration-200"
          >
            See How It Works
          </button>
        </div>

        {/* Trust line */}
        <p className="font-body text-xs text-vf-charcoal/50 tracking-wide">
          HIPAA-compliant &middot; Works offline &middot; Built for Rural Health Clinics (Section 330)
        </p>
      </div>
    </section>
  );
}
